module.exports = __webpack_public_path__ + "static/media/icons.bdb08373.ai";